// extracted by mini-css-extract-plugin
export default {"tag":"GlossarySection_tag__XMMCW","videoButton":"GlossarySection_videoButton__geh6W","content":"GlossarySection_content__-F+Sz"};